module.exports = __webpack_public_path__ + "img/sub.2e4ade88.png";